import { useLayoutEffect, useMemo, useRef } from 'react';

function useEventCallback (fn) {
	const ref = useRef(fn);
	useLayoutEffect(() => {
		ref.current = fn;
	});
	return useMemo(() => (...args) => (0, ref.current)(...args), []);
}


export default useEventCallback;

